import { combineReducers } from 'redux';
import { ItemReducer } from './../Reducers/ItemReducer';

const reducers = combineReducers({
    ItemReducer: ItemReducer,
});

export default reducers;
